export const DEFAULT_VENDOR_ID = 'lc'
